// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/preventZoom.css';
import './styles/new-tokens.css';
import { BrowserRouter } from 'react-router-dom';
import MainRoutes from './routes';
import { AuthProvider } from './hooks/authContext';
import { CobrancaStatusProvider } from './hooks/useCobrancaStatus';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <CobrancaStatusProvider>
        <BrowserRouter>
          <MainRoutes />
        </BrowserRouter>
      </CobrancaStatusProvider>
    </AuthProvider>
  </React.StrictMode>
);